import React from "react";
import AppointmentMiniCard from "../global/AppointmentMinCard";

export default function HomeNextAppointment({ appointment }) {
  return (
    <section className="p2-next-appointment">
      <p className="p2-next-title">Takimi yt i radhës</p>

      {appointment ? (
        <AppointmentMiniCard appointment={appointment} />
      ) : (
        <p className="p2-next-empty">
          Nuk ke asnjë takim të planifikuar. Mund të prenotosh një vizitë të re
          nga “Explore”.
        </p>
      )}
    </section>
  );
}
